/**
 * Persistent storage for stroring and sharing application data
 */

import { IDBPDatabase, openDB } from "idb";
import { StoreName } from "../types/Storage";
const _logPrefix = "[ADPClient][Storage]"; 
const storeObjects:StoreName[] = ["sci-state-indexed","adc-tracker-indexed","adp-device-validation-indexed","adp-session-references","adp-state-indexed","adp-transfer-status"]
const indexDBStorage = {
    adpStorage: (undefined) as unknown as IDBPDatabase,
    adpStorageName: "npd-ng-adp-storage-v2",
    async openDB(version:number){
        ("unknown") as unknown as IDBPDatabase
        const db:IDBPDatabase = await openDB(indexDBStorage.adpStorageName, version, {
            upgrade(db, oldVersion, newVersion, transaction, event) {               
                console.log(_logPrefix,indexDBStorage.adpStorageName,"upgrade event", oldVersion, newVersion, transaction, event);
                storeObjects.forEach((objectName)=>{
                    if(!db.objectStoreNames.contains(objectName)){
                        switch (objectName) {
                            case 'adc-tracker-indexed':
                                const adcTrackerStore = db.createObjectStore('adc-tracker-indexed',{keyPath: 'eventDateTime'});
                                adcTrackerStore.createIndex("clientLaunchId-index","clientLaunchId");
                              break;
                            case "adp-device-validation-indexed":
                                const adpDeviceValidationStore = db.createObjectStore('adp-device-validation-indexed');
                                adpDeviceValidationStore.createIndex("clientLaunchId-index",'clientLaunchId');
                                break;
                            case "adp-state-indexed":
                                const adpStateStore = db.createObjectStore('adp-state-indexed',{keyPath: 'clientLaunchId'});
                                adpStateStore.createIndex("clientLaunchId-index",'clientLaunchId');
                              break;
                              case "sci-state-indexed":
                                const sciStateStore = db.createObjectStore('sci-state-indexed',{keyPath: 'eventDateTime'});
                                sciStateStore.createIndex("clientLaunchId-index",'clientLaunchId');
                              break;
                              case "adp-transfer-status":
                                db.createObjectStore('adp-transfer-status',{keyPath: 'fileName'});
                              break;
                              case "adp-session-references":
                                db.createObjectStore('adp-session-references');
                              break;
                            default:
                              console.log(`No matching store object name`, objectName);
                          }
                    }
                    
                })            },
            blocked(currentVersion, blockedVersion, event) {
                console.log(_logPrefix,indexDBStorage.adpStorageName,"blocked event", currentVersion, blockedVersion, event);
            },
            blocking(currentVersion, blockedVersion, event) {
                console.log(_logPrefix,indexDBStorage.adpStorageName,"blocking event", currentVersion, blockedVersion, event);
            },
            terminated() {
                console.log(_logPrefix,"blocking event",indexDBStorage.adpStorageName);
            },
          });
          indexDBStorage.adpStorage = db;    
    },
    async getInstance(){
        if(!indexDBStorage.adpStorage){
           await indexDBStorage.openDB(2);
           return indexDBStorage;
        }
        else {
            return indexDBStorage;
        }
    },
    transactions: {
        async get(storeName:StoreName,query:string){
                return indexDBStorage.adpStorage.get(storeName,query);
            },
            async delete(storeName:StoreName,key:string){
                return indexDBStorage.adpStorage.delete(storeName,key);
            },
            async clear(){
                return indexDBStorage.adpStorage.clear(indexDBStorage.adpStorageName);
            },
            async add(storeName:StoreName,value:any){
                return indexDBStorage.adpStorage.add(storeName,value);
            },
            async put(storeName:StoreName,value:any,key?: string){
                if(key) return indexDBStorage.adpStorage.put(storeName,value,key);
                return indexDBStorage.adpStorage.put(storeName,value);
            },
            async getAll(storeName:StoreName){
                return indexDBStorage.adpStorage.getAllKeys(storeName);
            }
    },
    storeValidationLogs: async (value:any,key:string)=>{
        try {
            const instance = await indexDBStorage.getInstance();
            console.log("adding to the device-validation indexdb")
            await instance.transactions.put("adp-device-validation-indexed",value,key);
            return;
        }
        catch(e){
            console.error("[IndexDBStorage]","failed to persist validation logs",e);
            return;
        }                 
}
}

export {indexDBStorage};